<template>
  <div class="footer-bottom">
    <div class="footer-copyright">
      <p>&copy; {{ currentYear }} AppScontrini.it - ISIGest S.r.l. Tutti i diritti riservati.</p>
    </div>
    <div class="footer-legal">
      <p>
        Conforme al <strong>GDPR</strong> (Regolamento UE 2016/679) e al 
        <strong>D.Lgs. 196/2003</strong> come modificato dal <strong>D.Lgs. 101/2018</strong>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterBottom',
  computed: {
    currentYear() {
      return new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.footer-bottom {
  position: relative;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  padding-top: 2rem;
  margin-top: 3rem;
  text-align: center;
  animation: fadeIn 0.8s ease-out 0.5s both;
}

.footer-bottom::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
}

.footer-copyright {
  margin-bottom: 1rem;
}

.footer-copyright p {
  margin: 0;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 400;
  letter-spacing: 0.3px;
}

.footer-legal {
  margin-top: 1rem;
}

.footer-legal p {
  margin: 0;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.7;
}

.footer-legal strong {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

@media (max-width: 768px) {
  .footer-bottom {
    text-align: left;
    padding-top: 1.5rem;
    margin-top: 2rem;
  }

  .footer-bottom::before {
    left: 0;
    transform: none;
    width: 60px;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>

